import * as React from 'react';

var _g, _defs;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgCoinOutline = function SvgCoinOutline(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
    }, props), _g || (_g = /*#__PURE__*/ React.createElement("g", {
        clipPath: "url(#clip0_140_6740)"
    }, /*#__PURE__*/ React.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M18.286 17.835c1.305-.956.284-4.705-2.303-8.42v-.01c-2.6-3.704-5.777-5.977-7.139-5.1l-.022.023m9.464 13.507-.022.023m.022-.023-.022.023m0 0c-.863.585-2.463-.113-4.2-1.677-.249-.225-.51-.473-.76-.732a21 21 0 0 1-2.201-2.679 22 22 0 0 1-1.76-2.994 14 14 0 0 1-.42-.968c-.862-2.15-.964-3.894-.101-4.48m9.442 13.53-4.097 2.814c-1.35.923-4.55-1.35-7.161-5.088S3.374 8.065 4.725 7.142l4.097-2.814m-2.633 8.43 2.848-1.946m3.223 4.592-2.848 1.947"
    }))), _defs || (_defs = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", {
        id: "clip0_140_6740"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "transparent",
        d: "M3 3h17v19H3z"
    })))));
};

export { SvgCoinOutline as ReactComponent };
//# sourceMappingURL=CoinOutline.svg.es.js.map
